import { defineComponent as _defineComponent } from 'vue'
import { useIsDesktop } from "@/features/useIsDesktop";
  import { getDocumentName } from "@/helpers/documents";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderLotDocuments',
  props: {
    documents: {
      type: Array,
      required: true,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

  const openPdf = (link: string) => {
    window.open(link, "_blank");
  };

  const { isDesktop } = useIsDesktop();

const __returned__ = { props, openPdf, isDesktop, get useIsDesktop() { return useIsDesktop }, get getDocumentName() { return getDocumentName } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})